import { TextFieldProps } from '@mui/material';
import { FC } from 'react';
import { useDirectionsQuery } from '../../generated/graphql';
import useConcession from '../../hooks/useConcession';
import config from '../../services/config';
import SelectAutocompleteDataField from '../SelectAutocompleteDataField/SelectAutocompleteDataField';

interface DirectionFieldProps {
    textFieldProps?: TextFieldProps
    disabled?: boolean
}

const DirectionField: FC<DirectionFieldProps> = props => {
    const { textFieldProps = { variant: "standard" }, disabled } = props
    const concession = useConcession()
    return (
        <SelectAutocompleteDataField
            name="direction"
            label="Sentido"
            query={useDirectionsQuery}
            textFieldProps={textFieldProps}
            disabled={disabled}
            queryPaging={config.DEFAULT_FIELD_QUERY_PAGING}
            queryFilter={{
                concession: {
                    id: {
                        eq: concession?.id
                    }
                }
            }}
        />
    )
}

export default DirectionField
